import css from 'styled-jsx/css';

export default css`.login-container {
    box-sizing: border-box;
    .bottom-switch-type {
        text-align: right;
        padding-bottom: 5px;
        font-size: 0;
        margin-top: -18px;
        a {
            display: inline-block;
            font-size: 12px;
            font-weight: 400;
            color: #ccc;
            line-height: 12px;  
            padding: 0 8px;
        }
        a:first-child {
            border-right: 1px solid #ccc;
        }
    }
    // 一些覆盖antd样式
    :global(.ant-input) {
        border: none;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        background: transparent;
    }
    :global(.ant-select-selector) {
        border: none;
        box-shadow: none;
    }
    :global(.login-form-item-tel .ant-input-group-addon) {
        border: none;
        background: transparent;
        padding-left: 0;
        padding-right: 0;
        position: relative;
    }
    :global(.login-form-item-tel .ant-input-group-addon::after) {
        content: '';
        background-color: rgba(204, 204, 204, .3);
        position: absolute;
        height: 16px;
        width: 1px;
        top: 11px;
        right: 0;
    }
    :global(.login-form-item-smscode .ant-input-group-addon) {
        border: none;
        background: transparent;
        padding-left: 0;
        padding-right: 16px;
    }
    :global(.ant-input-affix-wrapper) {
        border: none;
        padding-left: 16px;
        padding-right: 16px;
        background: transparent;
    }
    :global(.ant-form-item-control-input) {
        border: 1px solid #F6F6F8;
        border-radius: 20px;
        overflow: hidden;
        background: #F6F6F8;
    }
    :global(.ant-form-item-has-error .ant-form-item-control-input) {
        border: 1px solid #FFA39E;
        background: #FFF1F0;
    }
    :global(.select-region-code) {
        height: 38px;
        line-height: 38px;
        cursor: pointer;
    }
    :global(.select-region-code .region-code-select-modal) {
        position: fixed;
        z-index: 10;
    }
    :global(.select-region-code .code-show) {
        padding-left: 16px;
        padding-right: 16px;
        display: flex;
        align-items: center;
    }
    :global(.select-region-code .code) {
        font-size: 14px;
        font-weight: 400;
        color: #000000;
    }
    :global(.select-region-code .arrow-icon) {
        font-size: 0;
        width: 10px;
        height: 6px;
        margin-left: 7px;
    }
    :global(.select-region-code .arrow-icon svg) {
        width: 100%;
        height: 100%;
        display: block;
    }
    :global(.select-region-code .arrow-icon-transform svg) {
        width: 100%;
        height: 100%;
        display: block;
        transform: rotateX(180deg);
    }
    :global(.ant-select-arrow) {
        color: #ccc;
    }
    :global(.get-pwd-btn) {
        font-size: 12px;
        font-weight: 400;
        color: #FF6400;
        border-left: 1px solid rgba(204, 204, 204, .5);
        cursor: pointer;
        line-height: 17px;
        padding-left: 16px;
        padding-right: 8px;
    }
    :global(.get-smscode-btn) {
        font-size: 12px;
        font-weight: 400;
        color: #ccc;
        border-left: 1px solid rgba(204, 204, 204, .3);
        cursor: pointer;
        line-height: 17px;
        padding-left: 16px;
        padding-right: 8px;
    }
    :global(.get-smscode-btn-active) {
        color: #FF6400;
    }
    :global(.ant-input-group input) {
        padding-left: 16px;
        padding-right: 16px;
        background: transparent;
    }
    :global(.ant-input-focused, .ant-input:focus),
    :global(.ant-input-group input:focus) {
        border: none!important;
        box-shadow: none!important;
    }
    :global(input::-webkit-input-placeholder) {
        color: #ccc;
        font-size: 14px;
    }
    :global(input::-moz-input-placeholder) {
        color: #ccc;
        font-size: 14px;
    }
    :global(input::-ms-input-placeholder) {
        color: #ccc;
        font-size: 14px;
    }
    :global(input::placeholder) {
        color: #ccc;
        font-size: 14px;
    }
    :global(.account-tips) {
        font-size: 0;
    }
    :global(.account-tips svg) {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }
    :global(.form-item-pwd .ant-form-item-control-input-content) {
        width: 100%; // 兼容 ie11 width超出问题
    }
}

// 弹窗
.login-container-modal {
    padding: 0 60px;
    margin-top: 32px;
    :global(.login-submit-btn) {
        width: 100%;
        margin-top: 40px;
    }
    :global(.login-form-validator-message) {
        padding-top: 3px;
    }
}

// 内嵌页面
.login-container-component {
    padding: 0 24px;
    :global(.login-submit-btn) {
        width: 100%;
    }
    :global(.ant-form-item-explain, .ant-form-item-extra) {
        min-height: 20px;
        line-height: 20px;
    }
    :global(.ant-form-item) {
        margin-bottom: 20px;
    }
    :global(.ant-form-item-with-help) {
        margin-bottom: 0;
    }
}


`